
import React, { Component, useEffect } from 'react'
import { Card, CardBody, Badge } from 'reactstrap'
import { Button, Row, Col, Spin } from 'antd'
import QRCode from "react-qr-code"

class PaymentValidateMobileBanking extends Component {
    constructor(props) {
        super(props)
        this.state = {
            timeRemaining: { hours: 0, minutes: 0, seconds: 0 },
            isExpire: false
        }
        this.countdownInterval = null
        this.checkExpire(props.expireDatetime)
    }

    componentDidMount() {
        if (!this.state.isExpire) {
            this.startCountdown(this.props.expireDatetime)
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.expireDatetime) {
            if (!this.state.isExpire) {
                this.startCountdown(this.props.expireDatetime)
            }
        }
    }

    checkExpire(expireDatetime) {
        if (expireDatetime && (new Date(expireDatetime) > new Date())) {
            this.setState({ isExpire: true })
        }
    }

    startCountdown(expireDatetime) {
        if (expireDatetime) {
            const targetTime = new Date(expireDatetime)
            this.countdownInterval = setInterval(() => {
                const now = new Date()
                const timeDifference = targetTime - now
                if (timeDifference > 0) {
                    const hours = Math.floor(timeDifference / (1000 * 60 * 60))
                    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))
                    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000)
                    this.setState({ timeRemaining: { hours, minutes, seconds } })
                } else {
                    clearInterval(this.countdownInterval)
                    this.setState({ timeRemaining: { hours: 0, minutes: 0, seconds: 0 }, isExpire: true })
                }
            }, 1000)
        }
    }

    render() {
        const { timeRemaining, isExpire } = this.state
        const { statusMessage, mobileBankingUrl, statusDescription, loading, sourceType, redirectUrl, showCreateOrderButton } = this.props
        return (
            <>
                <Card>
                    <CardBody>
                        {loading ?
                            <> <div className='text-center'>  <Spin size="large" /></div> </> :
                            <>
                                <Row>
                                    <Col className="text-center">
                                        {(sourceType)
                                            ? <div className='mb-3'>
                                                <img src={`/img/mobile-banking/${sourceType}.png`} height={80} />
                                            </div>
                                            : null
                                        }
                                        <div>
                                            {mobileBankingUrl
                                                ? <QRCode value={mobileBankingUrl} />
                                                : <Spin />
                                            }
                                        </div>
                                    </Col>
                                    <Col className={"justify-content-center"}>
                                        <Row className="text-center">
                                            <Col xs={24} style={{ fontSize: "30px" }}>
                                                {
                                                    timeRemaining.hours || timeRemaining.minutes || timeRemaining.seconds
                                                        ? `Please pay within ${timeRemaining.hours ? timeRemaining.hours.toString().padStart(2, '0') + ":" : ""}${timeRemaining.minutes.toString().padStart(2, '0')}:${timeRemaining.seconds.toString().padStart(2, '0')}`
                                                        : isExpire ? <span className="text-danger"> Qr code mobile banking is expired </span>
                                                            : <Spin />
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="text-center">
                                            <Col xs={24} style={{ fontSize: "30px" }}>
                                                <Badge pill color="secondary">
                                                    {statusMessage}
                                                </Badge>
                                            </Col>
                                        </Row>
                                        {(statusDescription)
                                            ? <Row><Col xs={24} className="text-center">{statusDescription}</Col></Row>
                                            : null
                                        }
                                        {(showCreateOrderButton) ?
                                            <Row className="mt-2">
                                                <Col xs={24} className="text-center">
                                                    <Button type="dash" onClick={() => this.setUrl(redirectUrl, 0)}>Create new order</Button>
                                                </Col>
                                            </Row>
                                            : null
                                        }
                                        <Row className="mt-2">
                                            <Col xs={24} className="text-center">
                                                <Button type="dash" onClick={() => window.location.reload()} >Check your order again</Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </>
                        }
                    </CardBody>
                </Card>
            </>
        )
    }
}

export default PaymentValidateMobileBanking